import { CSSTransition } from 'react-transition-group';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import LeftMenuDesign from '../../../../components/common/LeftMenuDesign/LeftMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './LeftIslandCabinetDesignMenu.scss';
import DropdownFilter from '../../../../components/common/DropdownFilter/DropdownFilter';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { useEffect, useState } from 'react';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import Tag from '../../../../components/common/Tag/Tag';
import ListTypeModule from '../../../../components/common/ListTypeModule/ListTypeModule';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../../../../store/actions/product.action';
import { fetchModules } from '../../../../store/actions/module.action';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { getValueFromString } from '../../../../utils/data/getValue.utils';

const LeftIslandCabinetDesignMenu = ({ open, onClose, moduleType, title }) => {
  const [openSearch, setOpenSearch] = useState(false);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { products } = useSelector(state => state.product);
  const [modules, setModules] = useState([]);

  const [listTypeProduct, setListTypeProduct] = useState([]);

  useEffect(() => {
    const product = products.data?.find(
      item => item.type_design === moduleType
    );
    if (product) {
      const listTypeProduct = product.types
        ?.filter(item => item.id === '7bc78beda81a11f09604009337088a0d')
        .map(item => ({
          key: item.id,
          label: item.name,
        }));
      if (listTypeProduct.length) {
        setListTypeProduct([...listTypeProduct]);
      }
    }
    // if (product) {
    //   dispatch(fetchModules({ product_type: product.id }));
    //   // dispatch(fetchModules({}));
    // }
  }, [moduleType, products]);

  useEffect(() => {
    if (open)
      dispatch(
        fetchModules({ productType: '7bc78beda81a11f09604009337088a0d' })
      ).then(action => {
        if (action?.payload?.data) {
          const { data } = action?.payload;
          setModules([...data]);
        }
      });

    // Lấy tất cả module
    // dispatch(fetchModules({}));
  }, [open]);
  return (
    <LeftMenuDesign
      open={open}
      classNames={{ root: '!left-[60px] relative', content: '!p-0 gap-0' }}
      styles={{ content: { background: '#F7F7F7' } }}
      header={
        <>
          <span className="text-title-large text-nowrap">{title}</span>
          <ButtonIconGhostSmall icon={<Icon.ICClose />} onClick={onClose} />
        </>
      }
      content={
        <>
          <div className="left-cabinet-design-menu-header-actions bg-fills-white">
            <div className="flex self-stretch">
              <CSSTransition
                in={!openSearch}
                classNames={'container-dropdown'}
                appear
                timeout={300}
              >
                <div className={'flex items-start gap-8 self-stretch'}>
                  <DropdownFilter
                    trigger={['click']}
                    menu={{
                      items: [
                        ...listTypeProduct.map(item => ({
                          ...item,
                          label: (
                            <div
                              className="flex px-12 py-8 justify-between items-center"
                              onClick={() => {}}
                            >
                              <span className="text-body-medium">
                                {getValueFromString(item.label)}
                              </span>
                              {'7bc78beda81a11f09604009337088a0d' ===
                                item.key && (
                                <span className="w-20 h-20 flex">
                                  <Icon.ICCheck />
                                </span>
                              )}
                            </div>
                          ),
                        })),
                      ],
                    }}
                    size="default"
                    className={'flex-row-reverse grow'}
                    value={getValueFromString(
                      listTypeProduct.find(
                        item => item.key == '7bc78beda81a11f09604009337088a0d'
                      )?.label ?? t('Please select')
                    )}
                  />
                  <ButtonIconOutlineMedium
                    icon={<Icon.ICSearch />}
                    onClick={() => {
                      // setOpenSearch((prev) => !prev);
                    }}
                  />
                </div>
              </CSSTransition>
              <CSSTransition
                in={openSearch}
                classNames={'container-search'}
                appear
                timeout={300}
              >
                <div
                  className={
                    'flex flex-col justify-start items-start bg-fills-white rounded-[8px] outline container-search'
                  }
                >
                  <div className="flex items-center gap-2">
                    <SearchComponent
                      value={''}
                      setValue={function (value) {}}
                      size="small"
                      styles={{ input: { width: '100%' } }}
                    />
                    <ButtonIconGhostMedium
                      icon={<Icon.ICClose />}
                      onClick={() => setOpenSearch(false)}
                    />
                  </div>
                  <div className="flex flex-col items-start gap-2 mt-16">
                    <div
                      className="flex p-8 items-center gap-8 self-stretch text-body-small"
                      style={{ color: '#5A5D60' }}
                    >
                      Tủ đơn
                    </div>
                  </div>
                </div>
              </CSSTransition>
            </div>
            {/* <ListTypeModule /> */}
            {/* </div> */}
          </div>
          <div className="grid grid-cols-2 p-8 justify-start items-start gap-2 self-stretch overflow-auto">
            <>
              {/* <CardProduct
                title={
                  <span className="text-body-medium-emphasized">
                    {t("custom kitchen cabinets")}
                  </span>
                }
                description1={
                  <span className="text-body-small">800 - 2000 mm</span>
                }
                description2={
                  <Tag
                    label={
                      <div
                        className="flex items-center gap-4"
                        style={{ color: "#5A5D60" }}>
                        <span className="w-16 h-16 flex">
                          <Icon.ICTuneColor />
                        </span>
                        <span className="text-label-small">
                          {t("customize")}
                        </span>
                      </div>
                    }
                    className="justify-start w-fit grow"
                  />
                }
                moduleType={moduleType}
              /> */}
              {modules?.map(item => {
                const name = getValueFromString(item.name);
                const description = getValueFromString(item.description ?? '');

                return (
                  <CardProduct
                    key={item.id}
                    md={item}
                    title={name}
                    description1={description}
                    description2={item.size}
                    // description2={
                    //   <span className="text-body-medium-emphasized">2,450,000 đ</span>
                    // }
                    moduleType={item.moduleType}
                  />
                );
              })}
            </>
          </div>
        </>
      }
    />
  );
};

export default LeftIslandCabinetDesignMenu;
